export default __webpack_public_path__ + "static/media/loadingTwo.7e4ac5e6.gif";